import { createContext } from "react";
import useLocales from "../hooks/locale/useLocales";

interface ILocaleContext extends ReturnType<typeof useLocales> {

}

const LocalesContext = createContext<ILocaleContext>({
    data: undefined,
    error: undefined,
    loading: false,
    mutate: async () => undefined,
    refresh: async () => undefined,
    validating: false
});


export default LocalesContext;